const demoState = {
    status: {
        isOpenModal: false
    }
};

const demo = {
    namespaced: true,
    state: demoState,
    getters: {
        isOpenModal(state) {
            return state.status.isOpenModal;
        }
    },
    mutations: {
        setStatus(state, payload) {
            Object.assign(state.status, payload);
        },
        reset(state) {
            // 現在は使用していないisDemoUserを削除する
            delete state.status.isDemoUser;
            Object.assign(state.status, demoState.status);
        }
    },
    actions: {
        setStatus({ commit }, response) {
            commit('setStatus', response);
        },
        reset({ commit }) {
            commit('reset');
        }
    }
};

export default demo;
